import React from 'react';
import { useSelector } from 'react-redux';
import { Integrations } from '@axtria/hqi-configurator'
import '@axtria/hqi-configurator/lib/hqi-configurator.css'
const baseURL = process.env.REACT_APP_HQI_BASE_URL
const UMUrl = process.env.REACT_API_URL

const Integration = () => {
  const userInfo = useSelector((state: any) => state.loginResource);

  return <>{userInfo?.preferredProject && <Integrations
    key={userInfo?.preferredProject}
      DOMAIN={baseURL}
      USER_ID={65}
      PROJECT_ID={userInfo?.preferredProject}
      DOMAIN_UM={UMUrl}
    />}</>;
};

export default Integration;
